module.exports = __webpack_public_path__ + "static/media/Misljenje-Ministarstva-zdravlja.7cd87bd2.pdf";